import Axios from '@/api/http'

/**
 * 获取数据日志
 * */
export function getapprovingoploglist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovingoploglist',
    data: date
  })
}
